<!--待处理-->
<template>
  <div class="load-areas">
      <div class="d-end-start" v-if="isAdmin">
        <!-- <el-tabs v-model="orderStatus" type="card">
          <el-tab-pane :name="item.status" v-for="item in tabArr" :key="item.title">
            <label slot="label" class="pointer">{{item.title}}
              <span class="unread-msg grey" :class="item.value" v-if="showUnread(item) > 0">{{showUnread(item)}}</span>
            </label>
          </el-tab-pane>
        </el-tabs> -->
      </div>
        <ul class="list-head tablie">
          <li :class="item.w" v-for="item in titleArr" :key="item.title">
            <img class="img-i" 
            img :src="'/images/public/sj-'+Sorts+'.png'" 
            v-if="item.title=='需求/报价/人数'"
            @click="sort"
            >
            <span>{{item.title}}</span>
          </li>
        </ul>
        <div  v-if="!loading">
          <div v-for="(item,index) in this.storeInfo.type==3?OrderLists:QuotationLists" :key="index+1">
            <hotel-order-itemize 
            :cardItem="item" 
            @goForDetail="goForDetail" 
            @getOrderList="getOrderList"
            @getOrderFlag="getOrderFlag"
            />
          </div>
          <p class="mt-3" v-if="this.storeInfo.type==3?OrderLists.length<=0:QuotationLists.length<=0">未查询到数据</p>
          <el-pagination background layout="prev, pager, next" class="mt-4 pagination" v-if="Number(TotalOrder) > 0"
            :total="Number(TotalOrder)" :current-page="Number(queryCon.page)"                     
          @current-change="$GFUN.pageChange" />
        </div>
        <p class="jzk" v-loading="loading" v-if="loading"></p>
  </div>
</template>

<script>
import SearchCon from './SearchCon'
import HotelOrderItemize from './HotelOrderItemize'
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
import { debounce } from "lodash";
export default {
  name: 'IndexHandle',
  components: {SearchCon,HotelOrderItemize},
  props: {},
  data() {
    return {
       orderStatus: '0',
       Sorts:0,
       orderType: 3,
        loading:false,
    };
  },
  computed: {
    ...mapState(['QuotationLists','newMessageInform','TotalOrder','OrderNumInfo','IndexData','OrderLists']),
    ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
    queryCon() {      //使用路由来记录的页数和订单类型、订单状态
      return this.$route.query
    },
      tabArr() {
        switch (this.storeInfo.type) {
          case 99:
            return [
              {title: '询价中', status: '1',value:'red'}, 
            ]
          default:
            return []
        }
      },
      titleArr() {
        let arr = [{title: '团号/酒店', w: 'w-30'}, {title: '订单类型', w: 'w-10'}, {title: '需求/报价/人数', w: 'w-30'},{title: '状态', w: 'w-15'}, {title: '操作', w: 'w-15'}];
        return arr;
      },
  },
  watch: {
      newMessageInform(newVal) {
        //收到通知刷新当前页面
        if (newVal && this.$GFUN.isInArray([5,6,7,39,40,42,43,46,47,56],newVal.type)){
          this.loading = true;
          this.getOrderList()
        }
      },
      orderStatus(newVal) {
        let query = {...this.queryCon, page: 1, orderStatus: newVal};
        this.$router.push({name: this.$route.name, query})
      },
      'queryCon.page': 'getOrderList',
      'queryCon.orderStatus'(newVal) {
        if (newVal) {
          this.orderStatus = newVal;
          this.loading = true;
          this.getOrderList();
        }
      },
  },
  created() {
    if (this.queryCon.orderType) this.orderType = Number(this.queryCon.orderType);
    if (this.queryCon.orderStatus) this.orderStatus = this.queryCon.orderStatus;
    this.loading = true;
    this.getOrderList();
  },
  mounted() {},
  methods: {
    ...mapActions(['hGetOrderOffer','hGetOrderLists']),
      /*开始标记*/
      getOrderFlag(e){
        this.flagtiem=e;
        this.showConfirmPanel=true;
      },
      /*排序*/
      sort(){
        if(this.Sorts!=2){
          this.Sorts++
        }else{
          this.Sorts=0
        }
        this.loading = true;
        this.getOrderList()
      },
      getOrderList: debounce(function(clearIndex = false) {
         let data={};
        switch (this.storeInfo.type) {
            case 3:
              data={status:1,type:3};
              this.hGetOrderLists({type:2,data,successFun:()=>{this.loading = false}});
            break;
            case 99:
            data={status:4};
              this.hGetOrderOffer({type:99,data,successFun:()=>{this.loading = false}});
            break;
        }
      },500),
            /*跳转查看订单详情页*/
      goForDetail(cardItem) {
        this.$router.push({
          name: 'OrderDetail',
          query: {
            orderType: this.orderType,
            orderId: cardItem.oid,
            storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
            status: cardItem.status,
            Handle:1,
            match_store_id:cardItem.match_store_id,
            GST: this.isGroup ? (cardItem.store_name || cardItem.appoint_name || cardItem.company) : ''
          }
        });
        // window.open(routeUrl.href, '_blank');
      },
      //显示待处理订单
      showUnread(item) {
        switch (this.userInfo.type) {
          case 3:
            switch (item.title) {
              case '询价中':
                return this.OrderNumInfo.status_4;
              default:
                return 0;
          }
          case 99:
            switch (item.title) {
              case '询价中':
                return this.OrderNumInfo.status_4;
              default:
                return 0;
          }
          default:
            return 0;
        }
      },
  }
};
</script>

<style lang="scss" scoped>
  .load-areas{
    padding: 20px 30px;
    min-height: calc(75vh);
  }
  .d-end-start .el-tabs{
    background-color: #fff;
  }
  .unread-msg {
    top: 0;
    right: 3px;
    left: auto;
  }
  .img-i {
    width: 15px;
    height: 15px;
    margin-right: 6px;
    cursor: pointer;
  }
  .tablie{
    background-color: #fff;
    border: 1px solid #EBF0F6;
    margin-top: -1px;   
  }
  .pagination{
    background-color: #fff;
    padding:12px 0;
    overflow: hidden;
  }
  .pointer{
        cursor: pointer;
  }
  .jzk{
    width: 100%;
    min-height: 300px;
    background-color: initial;
  }
</style>

